import { useMemo } from 'react';

import { invite as inviteService } from '@atlassian/expansion-services/services';

import { useService } from '@confluence/expansion-services';

export const useInvite = () => {
	const deps = useMemo(() => ({}), []);
	return useService(inviteService, deps);
};
